<template>
  <v-container>
    <v-row wrap>
      <template v-slot:extension>
        <v-tabs v-model="tab" color="cyan" grow>
          <v-tabs-slider color="yellow"></v-tabs-slider>

          <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in items" :key="item">
            <v-card>
              <v-card-text>{{ text }}</v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </template>

      <!-- timesheet added here -->
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <v-container>
              <v-card elevation="4" style="padding: 10px">
                <v-card-title>
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12 style="padding: 2px">
                        <full-datepicker @updateDate="updateDate"></full-datepicker>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs10 sm10 md10 style="padding: 2px">
                        <v-text-field
                          v-model="search"
                          @input="searchContents"
                          prepend-icon="search"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 sm2 md2 style="text-align: center; margin-top: 7px">
                        <v-menu>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" dark icon>
                              <v-icon class="black--text">more_vert</v-icon>
                            </v-btn>
                          </template>

                          <v-card class="elevation-0">
                            <v-card-text class="pa-0">
                              <v-list class="pa-0">
                                <v-list-item
                                  v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                                  to="/bulkattendance"
                                >
                                  <v-list-item-avatar>
                                    <v-icon dark color="primary">import_export</v-icon>
                                  </v-list-item-avatar>
                                  <v-list-item-content>Batch import</v-list-item-content>
                                </v-list-item>

                                <v-divider></v-divider>

                                <v-list-item @click="exportTimesheet" style="cursor: pointer">
                                  <v-list-item-avatar>
                                    <v-icon dark color="primary">get_app</v-icon>
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <!--<download-excel :data="punchDetails" :fields="timesheetReport_fields"-->
                                    <!--name="TimesheetReport.xls">-->
                                    <!--Download Timesheet-->
                                    <!--</download-excel>-->
                                    <!-- <download-csv
                                      :data="punchExportToCsv"
                                      name="AttendanceDataCSV.csv"
                                      >Export
                                    </download-csv>-->
                                    Export
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-title>

                <!-- Timesheet view -->
                <v-list three-line subheader>
                  <v-subheader>Timesheet</v-subheader>

                  <template>
                    <div v-if="visiblePunchDetails.length > 0" style="padding: 0px">
                      <v-list-item
                        v-for="item in _.filter(visiblePunchDetails, i => {
                          return i.visible;
                        })"
                        :key="item.id"
                        style="padding: 2px"
                      >
                        <v-list-item-avatar>
                          <v-avatar size="38px" color="primary">
                            <img
                              v-if="item.image"
                              :src="getImage(item.image, true)"
                              @click="zoom(item.image)"
                            />

                            <span v-else class="white--text headline">
                              {{ item.name.substring(0, 1) }}
                            </span>
                          </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                          <div>
                            <v-chip
                              :color="colorCalc(item.punchType)"
                              class="white--text"
                              label
                              small
                              >{{ item.punchType }}</v-chip
                            >
                          </div>

                          <small>{{ getLocationName(item.locationId) }}</small>
                          <small>
                            {{ item.time | moment("timezone", item.timezone.name, "lll") }} ({{
                              item.time | moment("timezone", item.timezone.name, "z")
                            }})
                            <span v-if="item.shiftName != ''"></span>
                          </small>

                          <span v-for="(shift, index) in item.originalShift" :key="index">
                            <small v-if="item.punchType == 'IN' && shift.offset">
                              {{ shift.name }} | Arrived {{ Math.abs(shift.offset.by) }} mins
                              <span v-if="!shift.offset.late">early</span>
                              <span v-else>late</span>
                            </small>
                            <small v-else-if="shift.offset">
                              {{ shift.name }} | Left
                              <span v-if="!shift.offset.late">early</span>
                              <span v-else>late</span>
                              by {{ Math.abs(shift.offset.by) }} mins
                            </small>
                          </span>
                        </v-list-item-content>

                        <v-list-item-action v-if="item.errorCount > 0">
                          <v-list-item-action-text>
                            <v-speed-dial v-model="item.expand" style="margin-right: 5px">
                              <template v-slot:activator>
                                <v-badge :overlap="true" right top>
                                  <template v-slot:badge>
                                    <span>{{ item.errorCount }}</span>
                                  </template>
                                  <v-btn v-model="item.expand" left color="warning" light fab small>
                                    <v-icon v-if="item.expand">close</v-icon>
                                    <v-icon v-else>error</v-icon>
                                  </v-btn>
                                </v-badge>
                              </template>

                              <v-btn v-if="item.outOfLocation == true" small light right>
                                <v-icon>location_disabled</v-icon>Out Of Location
                              </v-btn>

                              <v-btn v-if="item.hotspotDetected != false" small light right>
                                <span v-if="item.hotspotDetected == 1" color="red"
                                  >🦠 Containment Zone</span
                                >
                                <span v-else-if="item.hotspotDetected == 2" color="red"
                                  >🦠 Red Zone</span
                                >
                                <span v-else-if="item.hotspotDetected == 5" color="green"
                                  >🦠 Green Zone</span
                                >
                                <span v-else color="yellow">🦠 Yellow Zone</span>
                              </v-btn>

                              <v-btn v-if="item.imageMissing == true" small light right>
                                <v-icon>broken_image</v-icon>Image Missing
                              </v-btn>

                              <v-btn v-if="item.wifiMismatch == true" small light right>
                                <v-icon>wifi_off</v-icon>Wifi Mismatch
                              </v-btn>

                              <v-btn v-if="item.deviceMismatch == true" small light right>
                                <v-icon>device_unknown</v-icon>Device Mismatch
                              </v-btn>

                              <v-btn v-if="item.unapprovedManualPunch == true" small light right>
                                <v-icon>warning</v-icon>Pending Approval
                              </v-btn>

                              <!--<div v-for="itemChange in item.change" :key="itemChange.id"> -->
                              <v-btn
                                v-if="_.includes(item.pendingChanges, 'changeTime')"
                                small
                                light
                                right
                              >
                                <v-icon>restore</v-icon>Time Modification Request
                              </v-btn>

                              <v-btn
                                v-if="_.includes(item.pendingChanges, 'changeLocation')"
                                small
                                light
                                right
                              >
                                <v-icon>not_listed_location</v-icon>Location Modification Request
                              </v-btn>
                              <v-btn
                                v-if="_.includes(item.pendingChanges, 'deleteAttendance')"
                                small
                                light
                                right
                              >
                                <v-icon>delete</v-icon>Delete Request
                              </v-btn>

                              <v-btn
                                v-if="_.includes(item.pendingChanges, 'changePunchLocation')"
                                small
                                light
                                right
                              >
                                <v-icon>edit_location</v-icon>Change Punch Location
                              </v-btn>

                              <v-btn
                                v-if="_.includes(item.pendingChanges, 'changePunchType')"
                                small
                                light
                                right
                              >
                                <v-icon>pin_drop</v-icon>Change Punch Type
                              </v-btn>
                              <!--</div> -->
                            </v-speed-dial>
                          </v-list-item-action-text>
                        </v-list-item-action>

                        <v-list-item-action v-if="showAttendanceEdit(item)">
                          <v-list-item-action-text>
                            <v-btn
                              :to="{ name: 'Timesheet Edit', params: { attendanceId: item.id } }"
                              icon
                              ripple
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-list-item-action-text>
                        </v-list-item-action>

                        <v-list-item-action v-if="showAttendance(item)">
                          <v-list-item-action-text>
                            <v-btn @click="deleteAttendance(item.id)" icon ripple>
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-list-item-action-text>
                        </v-list-item-action>
                      </v-list-item>
                    </div>

                    <div v-else align="center">
                      <v-nodata
                        :loading="loading.timeSheetOptions"
                        :networkError="networkError.timeSheetOptions"
                        @retryMethod="showTimesheetReport"
                        title
                        msg-details="You haven't checked in yet"
                        icon="checkinguy"
                        content-bg="lighten-4"
                      ></v-nodata>
                    </div>
                  </template>
                </v-list>

                <!-- Pagination -->
                <!-- COMPONENT NOT NEEDED (NOT FINISHED) -->
                <!-- <Pagination
                v-if="renderComponent"
              :processedData="punchDetails" @process="getData">
                </Pagination>-->
                <v-col v-if="visiblePunchDetails.length > 0" class="col-12" sm="12" md="12">
                  <v-row>
                    <v-col class="col-12" sm="8" md="8">
                      <v-row wrap>
                        <v-col class="col-8" sm="4" md="4">
                          <v-select
                            v-model="records"
                            :items="rowsPerPage"
                            @change="getVisibleData"
                            label="Records per page"
                            style="margin-top: -2px; font-size: 14px"
                            dense
                            outlined
                          ></v-select>
                        </v-col>

                        <v-col class="col-2" sm="2" md="2">
                          <v-btn
                            @click="prev"
                            :disabled="currentPage != 0 ? false : true"
                            fab
                            text
                            small
                            color="primary"
                          >
                            <v-icon>navigate_before</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col class="col-2" sm="2" md="2">
                          <v-btn
                            :disabled="currentPage == totalPages - 1 ? true : false"
                            @click="next"
                            fab
                            small
                            color="primary"
                            text
                          >
                            <v-icon>navigate_next</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-row>

    <v-btn @click="addManualPunch" color="primary" dark fixed bottom right fab>
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="addManualDialog" persistent max-width="400px">
      <v-card elevation="2" style="border-radius: 3px">
        <v-card-title class="primary">
          <h4 class="reg__heading">Add Punch</h4>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-select
                  v-model="selectedUserId"
                  :items="userList"
                  @change="selectedPunchUser()"
                  item-text="name"
                  item-value="id"
                  label="Select User"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-select
                  v-model="selectedUserLocationId"
                  :items="userlocationList"
                  item-text="name"
                  item-value="id"
                  label="Select Location"
                ></v-select>
              </v-flex>

              <!-- <v-row wrap> -->
              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-select
                  v-model="selectedPunchType"
                  :items="punchTypeData"
                  item-text="text"
                  item-value="value"
                  label="Select Punch Type"
                ></v-select>
              </v-flex>

              <!-- <v-flex xs12 sm10 offset-sm1 md10 offset-md1 class="reg__custom__flex" style="margin: 10px 0px; "> -->

              <!-- <v-flex xs3 sm3 md3 class="reg__custom__flex" style="text-align: left">
                      <h3 style="margin-top: 5px; font-size: 14px !important; font-weight: 400">Date</h3>
              </v-flex>-->
              <v-flex xs12 sm12 md12 style="text-align: center; padding:  5px;">
               <!-- <date-picker
                  v-model="selectedInTime"
                  type="datetime"
                  lang="en"
                  format="YYYY-MM-DD HH:mm:ss"
                  confirm
                ></date-picker> -->

               <v-datetime-picker label="Select Datetime" v-model="selectedInTime"  time-format="HH:mm:ss"> </v-datetime-picker>

              </v-flex>

              <!-- </v-flex> -->
              <v-flex
                v-if="dropPunchImageFile"
                xs12
                sm12
                md12
                class="reg__custom__flex"
                style="text-align: left"
              >
                <h3
                  style="font-size: 13px !important; font-weight: 400; letter-spacing: 0.5px; margin-top: 5px"
                >
                  Choose File
                </h3>
              </v-flex>
              <v-flex v-if="dropPunchImageFile" xs12 sm12 md12 class="reg__custom__flex">
                <v-file-input
                  :prepend-icon="false"
                  @change="onFileChange"
                  label="Select a file"
                  append-icon="cloud_upload"
                  outlined
                  dense
                ></v-file-input>
                <div id="preview">
                  <img v-if="imgUrl" :src="imgUrl" />
                </div>
              </v-flex>

              <v-flex
                v-if="punchMapEnable"
                xs12
                sm12
                md12
                style="padding-top: 4%;"
                class="reg__custom__flex"
              >
                <v-flex xs12 sm12 md12 class="reg__custom__flex">
                  <p>Select Punch Location</p>
                  <GmapMap
                    :center="inTimeData.coordinates"
                    :zoom="12"
                    map-type-id="terrain"
                    style="min-width: 200px; min-height: 400px;width:100%"
                  >
                    <GmapMarker
                      :position="inTimeData.coordinates"
                      :clickable="true"
                      :draggable="true"
                      @dragend="updateLocIn"
                      :icon="{
                        url: require('@/assets/ft.png'),
                        size: { width: 40, height: 40, f: 'px', b: 'px' },
                        scaledSize: { width: 40, height: 40, f: 'px', b: 'px' }
                      }"
                    />
                  </GmapMap>
                  <!-- <v-container> -->
                  <div style="text-align: right">
                    <v-btn
                      @click="geoCurrentLocation"
                      fab
                      small
                      color="primary"
                      style="margin-top: -110px; margin-right: 60px"
                      class="white--text"
                    >
                      <v-icon>my_location</v-icon>
                    </v-btn>
                  </div>
                  <v-row wrap>
                    <v-flex xs12 sm12 md12 class="reg__custom__flex">
                      <div class="group">
                        <gmap-autocomplete
                          :placeholder="placeholder"
                          :value="inTimeData.address"
                          @place_changed="setIntimeDataPlace"
                          :select-first-on-enter="true"
                          class="input"
                        ></gmap-autocomplete>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                      </div>
                    </v-flex>

                    <v-flex xs12 sm12 md12 class="reg__custom__flex">
                      <v-text-field
                        v-model="latLngBox.lat"
                        :value="inTimeData.coordinates.lat"
                        @input="updateLocIn()"
                        label="Latitude"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 class="reg__custom__flex">
                      <v-text-field
                        v-model="latLngBox.lng"
                        :value="inTimeData.coordinates.lng"
                        @input="updateLocIn()"
                        label="Longitude"
                      ></v-text-field>
                    </v-flex>
                  </v-row>
                  <!-- </v-container> -->
                </v-flex>
              </v-flex>
            </v-layout>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="addManualDialog = false" text color="primary">Close</v-btn>
          <v-btn
            :disabled="afterpunch"
            @click="attendancePunch()"
            color="primary"
            class="white--text"
            >Punch</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogZoom" max-width="40vw" content-class="reg__boxShadowHide">
      <img :src="selectedZoomImage" @click.stop="dialogZoom = false" alt width="100%" />
    </v-dialog>

    <v-overlay v-model="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- loader -->
    <v-dialog v-model="loader" persistent width="300">
      <v-card color="primary" style="padding: 5px">
        <v-card-text style="padding: 10px; color: #fcfcfc">
          <h3 style="font-size: 15px;color: #fcfcfc; margin: 7px 0px">Please stand by</h3>
          <v-progress-linear
            style="padding: 2px"
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import blob from "blob";
import { mapState } from "vuex";
import { EventBus } from "@/utilities/event-bus.js";
import { isMobile } from "mobile-device-detect";
//import DatePicker from "vue2-datepicker";
// /import "vue2-datepicker/index.css";
import moment from "moment-timezone";
import punch from "@/utilities/punch";
import vueDropzone from "vue2-dropzone";
import Avatar from "vue-avatar-component";
import VNodata from "@/components/Unavailable/nodata.vue";
import canSee from "@/utilities/canSee";
import Papa from "papaparse";

// import Pagination from "@/components/pagination/pagination.vue";

export default {
  components: {
    //DatePicker,
    vueDropzone,
    Avatar,
    VNodata
    // Pagination
  },

  data() {
    return {
      rowsPerPage: ["10", "20", "30", "100"],
      currentPage: 0,
      visiblePunchDetails: [],
      overlay: false,
      totalPages: null,
      loader: false,
      // renderComponent: true,
      selectedZoomImage: "",
      dialogZoom: false,
      selectedTimeStart: "",
      startDateTimesheetModal: false,
      selectedTimeEnd: "",
      endDateTimesheetModal: false,
      fab: false,
      loading: {
        timeSheetOptions: true
      },
      networkError: {
        timeSheetOptions: false
      },
      afterpunch: false,
      shifts: [],
      users: [],
      userData: "",
      latLngBox: { lat: 22.22, lng: 88.22 },
      locationList: [],
      userlocationList: [],
      punchTypeData: [
        {
          text: "IN",
          value: "IN"
        },
        {
          text: "OUT",
          value: "OUT"
        }
      ],
      userList: [],
      punchExportToCsv: [],
      punchDetails: [],
      selectedUserTz: {},
      userSelectPunchImage: "",
      selectedPunchType: "IN",
      allUsers: [],
      selectedTags: {},
      unsub: () => {},
      userProfileImage: "",
      selectedUserId: "",
      selectedTags: [],
      selectedUserLocationId: "",
      placeholder: "Search Address",
      dropPunchImageFile: false,
      punchMapEnable: false,
      addManualDialog: false,
      base64PunchImage: "",
      search: "",
      selectedInTime: "",
      selectedOutTime: "",
      imgUrl: "",
      inTimeData: {
        coordinates: {
          lat: 22.22,
          lng: 88.22
        },
        address: ""
      },
      outTimeData: {
        coordinates: {
          lat: 22.22,
          lng: 88.22
        },
        address: ""
      },
      dropOptions: {
        url: `${this.$store.state.endpoint}storages/regularli-neo.appspot.com/upload`,
        maxFilesize: 2, // MB
        maxFiles: 1,
        createImageThumbnails: false,
        previewsContainer: false,
        addRemoveLinks: false,
        dictDefaultMessage: '<i class="material-icons icon-design profileImage">edit</i>'
      },
      timesheetReport_fields: {
        LocationName: "locationName",
        Name: "name",
        Email: "email",
        // SupervisorName: 'supervisorName',
        Date: "dateCustom",
        Time: "timeCustom",
        Timezone: "timeZoneCustom",
        Punch: "punchType",
        Latitude: "gps.lat",
        Longitude: "gps.lng"
      },

      // selectedTime: [moment().subtract(5, 'days').toDate(),moment().toDate()],

      // selectedTimeStart: moment().subtract(5, 'days').format('YYYY-MM-DDTHH:mm:ss'),

      // selectedTimeEnd: moment().format('YYYY-MM-DDTHH:mm:ss'),

      notafter: new Date(),
      headers: [
        {
          text: "Image",
          align: "left",
          value: "inImage"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Time",
          align: "left",
          value: "inTime"
        },
        {
          text: "Duration",
          align: "left",
          value: "duration"
        },
        {
          text: "Day",
          align: "left",
          value: "attendanceDay"
        }
      ],
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.selectedTime = [new Date(), new Date()];
          }
        }
      ]
    };
  },
  computed: {
    records: {
      get: function() {
        if (this.$store.getters.pagination[this.$router.currentRoute.name]) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        } else {
          return "10";
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });

        //this.getPageDetails()
      }
    }
  },
  beforeDestroy() {
    this.unsub();
  },
  mounted() {},
  created() {
    //  EventBus.$on('showTimesheetReport',this.showTimesheetReport)

    const self = this;
    self.getLocationDetails();

    self.getShiftDetails();

    self.unsub = self.$store.subscribe((mutation, state) => {
      // if (mutation.type === 'setSelectedTags') {
      if (
        mutation.type === "setSelectedTags" ||
        mutation.type === "setMode" ||
        mutation.type === "setGroup"
      ) {
        const opts = {
          tags: _.map(
            _.filter(state.selectedTags, t => t.type == "tag"),
            "id"
          ),

          locations: _.map(
            _.filter(state.selectedTags, t => t.type == "location"),
            "id"
          ),

          mode: state.mode,
          group: state.group
        };

        self.showTimesheetReport(opts);
        self.selectedUserList(opts);
      }
    });

    console.log("Created calling");

    // self.showTimesheetReport(this.$store.getters.getSelectedTagsAndLocations);
    self.selectedUserList(this.$store.getters.getSelectedTagsAndLocations);

    if (isMobile) {
      document.addEventListener(
        "deviceready",
        () => {
          self.checkFTState();
        },
        false
      );
    }

    this.geoCurrentLocation();
  },
  methods: {
    async createExportPayload(punches) {
      try {
        punches = _.map(punches, d => {
          var payload = {};
          //export to csv
          payload.LocationName = d.locationName;
          payload.Email = d.email;
          payload.Punch = d.punchType;
          // payload.Address = "address" in d ? d.address.display_name : "";
          payload.Time = d.timeCustom;
          payload.Date = d.dateCustom;
          return payload;
        });

        return punches;
      } catch (e) {
        console.log("error", e);
      }
    },

    async exportTimesheet() {
      var data = [];
      data = await this.createExportPayload(this.punchDetails);
      var csv = Papa.unparse(data);

      if (this.$mq != "mobile") {
        try {
          var csvData = new Blob([csv], {
            type: "text/csv;charset=utf-8;"
          });

          var csvURL = null;
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, "download.csv");
          } else {
            csvURL = window.URL.createObjectURL(csvData);
          }

          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", "download.csv");
          tempLink.click();
        } catch (e) {
          console.log(e);
        }
      } else {
        window.resolveLocalFileSystemURL(cordova.file.cacheDirectory, function(dir) {
          console.log("dir", dir);
          dir.getFile(
            "export-timesheet-" + new Date().getTime() + ".csv",
            {
              create: true
            },
            function(file) {
              console.log("file", file);

              var logOb = file;

              function writeLog(str) {
                if (!logOb) return;
                logOb.createWriter(
                  function(fileWriter) {
                    fileWriter.seek(fileWriter.length);
                    var blob = new Blob([str], {
                      type: "text/csv;charset=utf-8;"
                    });
                    fileWriter.write(blob);
                    window.plugins.socialsharing.share(null, null, logOb.nativeURL, null);
                  },
                  () => {
                    this.$swal({ type: "error", text: "Something went wrong" });
                  }
                );
              }

              writeLog(csv);
            }
          );
        });
      }
    },

    // get location list
    getLocationDetails() {
      this.locationList = [];
      this.$http
        .get(
          `${this.$store.state.endpoint}locations?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          this.locationList = response.body;
        })
        .catch(error => {
          // console.log(error)
        });
    },
    // get shift details
    getShiftDetails() {
      this.shifts = [];
      this.$http
        .get(
          `${this.$store.state.endpoint}shifts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.shifts = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },
    // pagination visible data
    getVisibleData() {
      const self = this;
      self.overlay = true;
      this.totalPages = null;

      var records = Number(self.records); //record

      var filterData = _.filter(self.punchDetails, data => {
        return data.visible == true;
      });
      self.visiblePunchDetails = filterData;

      self.totalPages = Math.ceil(self.visiblePunchDetails.length / records);

      if (self.records == "All") {
        self.overlay = false;
        return (self.visiblePunchDetails = self.punchDetails);
      } else {
        self.visiblePunchDetails = self.visiblePunchDetails.slice(
          self.currentPage * records,
          self.currentPage * records + records
        );
      }

      self.overlay = false;
      return self.visiblePunchDetails;
    },
    // pagination next
    next() {
      this.currentPage++;
      this.getVisibleData();
    },
    // pagination prev
    prev() {
      this.currentPage--;
      this.getVisibleData();
    },

    // Search functionality
    async searchContents() {
      const self = this;

      if (self.search != "") {
        _.each(self.punchDetails, f => {
          var re = new RegExp(self.search.toLowerCase(), "g");

          if (f.name.toLowerCase().match(re) || f.email.toLowerCase().match(re)) {
            f.visible = true;
          } else if (self.search == "") {
            f.visible = true;
          } else {
            f.visible = false;
          }
        });
        self.getVisibleData();
      } else {
        _.each(self.punchDetails, f => {
          f.visible = true;
        });

        self.getVisibleData();
      }
    },

    zoom(url) {
      var fullPath = "";

      if (url == undefined) {
        fullPath = require("@/assets/demo.png");
        //return demoImg;
      } else {
        fullPath = this.$store.state.imagePath + url;
      }

      this.dialogZoom = true;
      this.selectedZoomImage = fullPath;
    },
    showAttendanceEdit(contextAtt) {
      if (this.$store.state.userDetails.role.toLowerCase() == "superadmin") {
        return true;
      } else if (this.$store.state.userDetails.role.toLowerCase() == "admin") {
        return true;
      } else if (contextAtt.userId == this.$store.state.userDetails.id) {
        return true;
      }
      return false;
    },
    showAttendance(contextAtt) {
      if (this.$store.state.userDetails.role.toLowerCase() == "superadmin") {
        return true;
      } else if (
        this.$store.state.userDetails.role.toLowerCase() == "admin" &&
        this.canSee("modifyTimesheet")
      ) {
        return true;
      } else if (contextAtt.userId == this.$store.state.userDetails.id) {
        return true;
      }
      return false;
    },

    updateDate(startDate, endDate) {
      this.selectedTimeStart = startDate;
      this.selectedTimeEnd = endDate;
      this.showTimesheetReport();
    },

    colorCalc(c) {
      return c === "OUT" ? "error" : "success";
    },
    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    deleteAttendance(attnId) {
      this.$swal({
        text: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "info",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.$http.delete(`${this.$store.state.endpoint}attendances/${attnId}/delete`).then(
            response => {
              // success callback
              this.showTimesheetReport();
            },
            error => {
              console.log(error);
              this.$swal({ type: "error", text: error.body.error.message });
              return error;
            }
          );
        }
      });
    },
    secondsToHms(d) {
      d = Number(d);
      const h = Math.floor(d / 3600);
      const m = Math.floor((d % 3600) / 60);
      const s = Math.floor((d % 3600) % 60);

      const hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      const mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      const sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay;
    },
    async onFileChange(e) {
      const files = event.target.files[0];

      this.imgUrl = URL.createObjectURL(files);

      function getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      }

      const self = this;
      this.base64PunchImage = await getBase64(files);

      // this.readFile()
    },

    attendancePunch() {
      this.loader = true;
      this.afterpunch = true;
      var punchObj = {};
      var self = this;
      if (this.base64PunchImage != "") {
        punchObj.image = this.base64PunchImage;
      }

      if (this.selectedUserId == "") {
        this.loader = false;
        this.afterpunch = false;
        return this.$swal({ type: "warning", text: "Select User" });
      } else if (this.selectedUserLocationId == "") {
        this.loader = false;
        this.afterpunch = false;
        return this.$swal({ type: "warning", text: "Select location" });
      } else if (this.selectedInTime == "") {
        this.loader = false;
        this.afterpunch = false;
        return this.$swal({ type: "warning", text: "Invalid date" });
      }

      punchObj.time = moment(this.selectedInTime)
        .tz(this.selectedUserTz.name, true)
        .format();
      punchObj.userId = this.selectedUserId;
      punchObj.locationId = this.selectedUserLocationId;
      punchObj.punchType = this.selectedPunchType;

      // punchObj.outTime = moment(this.selectedOutTime).format()

      punchObj.gps = {
        coords: {
          latitude: this.inTimeData.coordinates.lat,
          longitude: this.inTimeData.coordinates.lng
        }
      };

      punchObj.manualPunch = true;

      var today = moment().format("DD/MM/YYYY HH:mm:ss");
      var inputDate = moment(punchObj.time).format("DD/MM/YYYY HH:mm:ss");

      var duration = moment(today, "DD/MM/YYYY HH:mm:ss").diff(
        moment(inputDate, "DD/MM/YYYY HH:mm:ss"),
        "seconds"
      );

      if (duration < 0) {
        this.loader = false;
        this.afterpunch = false;
        this.$swal({
          type: "error",
          text: "Future date punches not allowed"
        });
        return;
      }

      /* this.$http.post(this.$store.state.endpoint+'attendances/punchBoth', punchObj)
         .then(()=>{
             self.addManualDialog = false
             self.showTimesheetReport()
         }) */

      // var self = this;

      punch(this, punchObj).then(
        response => {
          self.addManualDialog = false;
          self.showTimesheetReport();
          self.afterpunch = false;
          this.$swal({
            type: "success",
            title: "Attendance Sent",
            text: "Your attendance was sent successfully"
          });

          this.selectedUserId = "";
          this.selectedUserLocationId = "";
          this.selectedInTime = "";
          this.selectedOutTime = "";
          this.loader = false;
        },
        error => {
          // console.log(error);
          self.afterpunch = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });
          this.loader = false;
          this.dialog = false;
        }
      );
    },

    setIntimeDataPlace(place) {
      this.inTimeData.address = place.formatted_address;

      this.inTimeData.coordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
    },

    setouttimeDataPlace(place) {
      this.outTimeData.address = place.formatted_address;

      this.outTimeData.coordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
    },

    updateLocIn(newAddress) {
      const self = this;

      if (newAddress) {
        this.inTimeData.coordinates = {
          lat: newAddress.latLng.lat(),
          lng: newAddress.latLng.lng()
        };

        this.latLngBox = {
          lat: newAddress.latLng.lat(),
          lng: newAddress.latLng.lng()
        };
      } else {
        this.inTimeData.coordinates = {
          lat: Number(this.latLngBox.lat),
          lng: Number(this.latLngBox.lng)
        };
      }

      this.setAddress();
    },

    geoCurrentLocation() {
      const self = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.inTimeData.coordinates = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.latLngBox = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.setAddress();
        });
      }
    },

    setAddress() {
      const self = this;

      this.$gmapApiPromiseLazy().then(() => {
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ location: this.inTimeData.coordinates }, (results, status) => {
          if (status === "OK") {
            if (results[0]) {
              self.inTimeData.address = results[0].formatted_address;
            } else {
              return null;
            }
          }
        });
      });
    },

    /* updateLocIn(location) {

       
        this.inTimeData.coordinates.lat = location.latLng.lat()
        this.inTimeData.coordinates.lng = location.latLng.lng()


      },
      */
    updateLocOut(location) {
      this.outTimeData.coordinates.lat = location.latLng.lat();
      this.outTimeData.coordinates.lng = location.latLng.lng();
    },

    removeImg() {
      this.imgUrl = "";
      this.base64PunchImage = "";
    },
    removePunchImg() {
      this.userSelectPunchImage = "";
    },

    afterComplete(file, response) {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}storages/regularli-neo.appspot.com/files/${response.result.files.file[0].name}`
        )
        .then(
          res => {
            self.userSelectPunchImage = res.body.mediaLink;

            this.$refs.myVueDropzone.removeFile(file);
          },
          error => {
            this.$swal({ type: "error", text: error.body.error.message });
            console.log(error);
          }
        );
    },

    getLocationName(value) {
      for (const o in this.locationList) {
        if (this.locationList[o].id == value) {
          return this.locationList[o].name;
        }
      }
      return "";
    },

    selectedPunchUser() {
      this.userlocationList = [];
      this.$http
        .get(`${this.$store.state.endpoint}Accounts/${this.selectedUserId}`)
        .then(response => {
          // console.log("Accounts Response", response.body);
          // var locationIds = [];
          // this.punchData = [];

          this.selectedUserTz = response.body.tz;

          if (response.body.securitySettings.isPhotoid == true) {
            this.dropPunchImageFile = true;
          } else {
            this.dropPunchImageFile = false;
          }

          if (
            response.body.securitySettings.isGeoseal == true ||
            response.body.securitySettings.isFieldtracking == true
          ) {
            this.punchMapEnable = true;
          } else {
            this.punchMapEnable = false;
          }

          const item = response.body;
          // this.punchData = response.body;

          // console.log("item", item)

          var jsonObj = {};

          if (item.allowedLocations.length > 0 && item.allowedLocations != undefined) {
            for (var m in item.allowedLocations) {
              jsonObj = {
                name: this.getLocationName(item.allowedLocations[m]),
                id: item.allowedLocations[m]
              };

              this.userlocationList.push(jsonObj);
            }
          }

          console.log(`allowed locations for ${item.firstName}`, this.userlocationList);

          // locationIds.push(item.baseLocationId);

          // if (item.allowedLocations != undefined) {
          //   const self = this;

          // function getLocationName(value) {
          //   const locationData = self.locationList;
          //   for (const o in locationData) {
          //     console.log("locationData", locationData[o])
          //     if (locationData[o].id == value) {
          //       return locationData[o].name;
          //     }
          //   }
          // }

          // console.log("location Ids before condition", locationIds)
          // if (item.allowedLocations.length > 0) {
          //   for (var m in item.allowedLocations) {
          //     console.log(m)
          //     console.log(item.allowedLocations[m])
          //     locationIds.push(item.allowedLocations[m]);
          //     console.log("location Ids", locationIds)
          //     // const unique = [...new Set(locationIds)];

          //     for (var m in locationIds) {
          //       locationIds.name = self.getLocationName(locationIds[m]);
          //       locationIds.id = locationIds[m];
          //     }
          //     console.log("if case ", locationIds)
          //     this.userlocationList.push(locationIds);
          //   }
          // } else {
          //   const unique = [response.body.baseLocationId];

          //   for (var m in unique) {
          //     unique.name = getLocationName(unique[m]);
          //     unique.id = unique[m];
          //   }
          //   console.log("else case ", unique)
          //   this.userlocationList.push(unique);
          // }

          //   console.log(" user location list" ,this.userlocationList);
          // }
        });
    },

    selectedUserList(tags) {
      //console.log("By Filter of Accounts ", tags)

      if (typeof tags !== "undefined") this.selectedTags = tags;
      // else console.log('Using system tag', this.selectedTags);

      const self = this;

      this.$http
        .post(`${this.$store.state.endpoint}Accounts/byFilter`, {
          groupId: "all",
          mode: "OR"
        })
        .then(
          response => {
            var response = response.body;
            // console.log("User List",response)
            self.userList = [];

            if (self.canSee("modifyTimesheet")) {
              for (const m in response) {
                response[m].name = `${response[m].firstName} ${response[m].lastName}`;
                self.userList.push(response[m]);
              }
            } else {
              response = _.find(response, i => {
                return i.id == self.$store.state.userDetails.id;
              });
              response.name = `${response.firstName} ${response.lastName}`;
              self.userList.push(response);
            }

            // console.log(this.userList);
          },
          error => {
            this.loading.timeSheetOptions = false;
            this.networkError.timeSheetOptions = true;
            this.$swal({ type: "error", text: error.body.error.message });
          }
        );
    },

    addManualPunch() {
      console.log(this);

      this.addManualDialog = true;
    },

    getImage(src, small) {
      if (src == undefined) {
        const demoImg = require("@/assets/demo.png");
        return demoImg;
      }

      if (small) {
        src = src.insert(src.lastIndexOf("."), "_200x200");
      }

      return this.$store.state.imagePath + src;
    },
    getSupervisorName(value) {
      const self = this;
      const userData = self.allUsers;

      for (const o in userData) {
        if (userData[o].id == value) {
          return `${userData[o].supervisorDetails.firstName} ${userData[o].supervisorDetails.lastName}`;
        }
      }
    },
    getUserName(value) {
      const self = this;
      const userData = self.allUsers;
      for (const o in userData) {
        if (userData[o].id == value) {
          return `${userData[o].firstName} ${userData[o].lastName}`;
        }
      }
    },
    getEmail(value) {
      const self = this;
      const userData = self.allUsers;
      for (const o in userData) {
        if (userData[o].id == value) {
          return userData[o].email;
        }
      }
    },
    getShiftName(value) {
      return _.map(
        _.filter(this.shifts, s => {
          return _.includes(value, s.id);
        }),
        "name"
      ).join();
    },

    showTimesheetReport(tags) {
      this.loading.timeSheetOptions = true;

      if (typeof tags !== "undefined" && tags.hasOwnProperty("locations")) this.selectedTags = tags;

      this.punchDetails = [];
      if (typeof tags !== "undefined") this.selectedTags = tags;
      // else console.log('Using system tag', this.selectedTags);

      const self = this;

      //this.selectedTime[0] = moment(this.selectedTime[0]).hours(0).minutes(0).seconds(1).milliseconds(0)
      //this.selectedTime[1] = moment(this.selectedTime[1]).hours(23).minutes(59).seconds(59).milliseconds(0)

      var records = Number(this.records);
      var offset = this.currentPage * Number(this.records);

      //console.log("The time is " , this.selectedTimeEnd.format())
      //Translate Start and End date to UTC

      this.$http
        .post(`${this.$store.state.endpoint}attendances/byFilter`, {
          // tags: this.selectedTags.tags,
          // locations: this.selectedTags.locations,
          // mode: this.selectedTags.mode,
          // groupId: this.$store.getters.group,
          tags: this.selectedTags.tags,
          locations: this.selectedTags.locations,
          groupId: this.selectedTags.group,
          mode: this.selectedTags.mode,
          include: "supervisorDetails",
          showUnqiue: false,
          startDate: `${moment(this.selectedTimeStart)
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .format()}`,
          endDate: `${moment(this.selectedTimeEnd)
            .hours(23)
            .minutes(59)
            .seconds(59)
            .milliseconds(0)
            .format()}`
        })
        .then(
          response => {
            this.loading.timeSheetOptions = false;
            self.allUsers = response.body.users;
            var response = response.body.attendances;

            self.punchDetails = [];
            for (const x in response) {
              try {
                const time = moment(response[x].time);

                const userOffset = Number(response[x].timezone.offset);

                response[x].name = self.getUserName(response[x].userId);

                response[x].supervisorName = self.getSupervisorName(response[x].userId);

                response[x].email = self.getEmail(response[x].userId);

                response[x].shiftName = self.getShiftName(response[x].shift);

                response[x].dateCustom = time.tz(response[x].timezone.name).format("DD-MM-YYYY");

                response[x].timeCustom = time.tz(response[x].timezone.name).format("HH:mm:ss");

                response[x].timeZoneCustom = time.tz(response[x].timezone.name).format("z");

                if (response[x].originalShift && response[x].originalShift.length > 0) {
                  response[x].offset = _.map(response[x].originalShift, "offset");
                }
                // time
                /* if (response[x].time == '') {
                  response[x].time = ''
                } else {
                  response[x].time = moment(response[x].time).utcOffset(userOffset).format("hh:mm a")
                } */
                // get location details

                response[x].locationName = self.getLocationName(response[x].locationId);

                response[x].attendanceDay = moment(response[x].attendanceDay)
                  .utcOffset(userOffset)
                  .format("dddd, MMMM Do YYYY");

                response[x].expand = false;
                response[x].visible = true;

                self.punchDetails.push(response[x]);
              } catch (e) {
                console.log(e);
              }
            }
            // console.log("The punchDetails to be processed",self.punchDetails)

            var i = 0;

            //Lets make the changes part much easier to read
            self.punchDetails = _.map(self.punchDetails, item => {
              item.pendingChanges = _.map(_.filter(item.changes, { state: 0 }), "changeType");
              item.errorCount = 0;
              var c = 0;
              if (item.outOfLocation) c++;
              if (item.imageMissing) c++;
              if (item.wifiMismatch) c++;
              if (item.deviceMismatch) c++;
              if (item.unapprovedManualPunch) c++;
              if (item.hotspotDetected != false) c++;

              item.errorCount = c + item.pendingChanges.length;

              i++;

              item.lazyVisible = i < 30 ? true : false;
              return item;
            });

            self.getVisibleData();
          },
          error => {
            this.loading.timeSheetOptions = false;
            this.networkError.timeSheetOptions = true;
            this.$swal({ type: "error", text: error.body.error.message });
          }
        );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-card {
  margin-bottom: 0px !important;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.profile-picture:hover {
  border-color: #4caf50;
}

.profile-picture {
  background-color: #999999;
  border: 4px solid #999999;
  color: #ffffff;

  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}

.icon-design {
  background-color: #ffffff;
  border: 4px solid #cccccc;
  color: rgb(33, 150, 243);
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
  margin-left: 160px;
  margin-top: -22px;
}

.icon-design:hover {
  border-color: #4caf50;
}

.vue-dropzone {
  border: 4px solid #cccccc;
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  color: #fff;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

.vue-dropzone:hover {
  border-color: #4caf50;
}

.dropzone {
  min-height: 30px;
  background: white;
  padding: 0px;
  background-color: #ffffff;
  color: rgb(33, 150, 243);
  border-radius: 50%;
  width: 35px;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}

@-webkit-keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }

  30%,
  70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }

  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
  }
}

@-moz-keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }

  30%,
  70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }

  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
  }
}

@keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }

  30%,
  70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }

  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
  }
}

@-webkit-keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }

  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@-moz-keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }

  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }

  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }

  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1);
  }

  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

@-moz-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }

  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1);
  }

  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }

  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1);
  }

  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

.dropzone,
.dropzone * {
  box-sizing: border-box;
}

.dropzone.dz-clickable {
  cursor: pointer;
}

.dropzone.dz-clickable * {
  cursor: default;
}

.dropzone.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message * {
  cursor: pointer;
}

.dropzone.dz-started .dz-message {
  display: none;
}

.dropzone.dz-drag-hover {
  border-style: solid;
}

.dropzone.dz-drag-hover .dz-message {
  opacity: 0.5;
}

.dropzone .dz-message {
  text-align: center;
  margin: 0px;
}

.dropzone .dz-preview {
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin: 16px;
  min-height: 100px;
}

.dropzone .dz-preview:hover {
  z-index: 1000;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-file-preview .dz-image {
  border-radius: 20px;
  background: #999;
  background: linear-gradient(to bottom, #eee, #ddd);
}

.dropzone .dz-preview.dz-file-preview .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-image-preview {
  background: white;
}

.dropzone .dz-preview.dz-image-preview .dz-details {
  -webkit-transition: opacity 0.2s linear;
  -moz-transition: opacity 0.2s linear;
  -ms-transition: opacity 0.2s linear;
  -o-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}

.dropzone .dz-preview .dz-remove {
  font-size: 14px;
  text-align: center;
  display: block;
  cursor: pointer;
  border: none;
}

.dropzone .dz-preview .dz-remove:hover {
  text-decoration: underline;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview .dz-details {
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 13px;
  min-width: 100%;
  max-width: 100%;
  padding: 2em 1em;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  line-height: 150%;
}

.dropzone .dz-preview .dz-details .dz-size {
  margin-bottom: 1em;
  font-size: 16px;
}

.dropzone .dz-preview .dz-details .dz-filename {
  white-space: nowrap;
}

.dropzone .dz-preview .dz-details .dz-filename:hover span {
  border: 1px solid rgba(200, 200, 200, 0.8);
  background-color: rgba(255, 255, 255, 0.8);
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
  border: 1px solid transparent;
}

.dropzone .dz-preview .dz-details .dz-filename span,
.dropzone .dz-preview .dz-details .dz-size span {
  background-color: rgba(255, 255, 255, 0.4);
  padding: 0 0.4em;
  border-radius: 3px;
}

.dropzone .dz-preview:hover .dz-image img {
  -webkit-transform: scale(1.05, 1.05);
  -moz-transform: scale(1.05, 1.05);
  -ms-transform: scale(1.05, 1.05);
  -o-transform: scale(1.05, 1.05);
  transform: scale(1.05, 1.05);
  -webkit-filter: blur(8px);
  filter: blur(8px);
}

.dropzone .dz-preview .dz-image {
  border-radius: 20px;
  overflow: hidden;
  width: 120px;
  height: 120px;
  position: relative;
  display: block;
  z-index: 10;
}

.dropzone .dz-preview .dz-image img {
  display: block;
}

.dropzone .dz-preview.dz-success .dz-success-mark {
  -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
  -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
  -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
  -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview.dz-error .dz-error-mark {
  opacity: 1;
  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
  -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
  -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
  -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark {
  pointer-events: none;
  opacity: 0;
  z-index: 500;
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  margin-left: -27px;
  margin-top: -27px;
}

.dropzone .dz-preview .dz-success-mark svg,
.dropzone .dz-preview .dz-error-mark svg {
  display: block;
  width: 54px;
  height: 54px;
}

.dropzone .dz-preview.dz-processing .dz-progress {
  opacity: 1;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.dropzone .dz-preview.dz-complete .dz-progress {
  opacity: 0;
  -webkit-transition: opacity 0.4s ease-in;
  -moz-transition: opacity 0.4s ease-in;
  -ms-transition: opacity 0.4s ease-in;
  -o-transition: opacity 0.4s ease-in;
  transition: opacity 0.4s ease-in;
}

.dropzone .dz-preview:not(.dz-processing) .dz-progress {
  -webkit-animation: pulse 6s ease infinite;
  -moz-animation: pulse 6s ease infinite;
  -ms-animation: pulse 6s ease infinite;
  -o-animation: pulse 6s ease infinite;
  animation: pulse 6s ease infinite;
}

.dropzone .dz-preview .dz-progress {
  opacity: 1;
  z-index: 1000;
  pointer-events: none;
  position: absolute;
  height: 16px;
  left: 50%;
  top: 50%;
  margin-top: -8px;
  width: 80px;
  margin-left: -40px;
  background: rgba(255, 255, 255, 0.9);
  -webkit-transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.dropzone .dz-preview .dz-progress .dz-upload {
  background: #333;
  background: linear-gradient(to bottom, #666, #444);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  -webkit-transition: width 300ms ease-in-out;
  -moz-transition: width 300ms ease-in-out;
  -ms-transition: width 300ms ease-in-out;
  -o-transition: width 300ms ease-in-out;
  transition: width 300ms ease-in-out;
}

.dropzone .dz-preview.dz-error .dz-error-message {
  display: block;
}

.dropzone .dz-preview.dz-error:hover .dz-error-message {
  opacity: 1;
  pointer-events: auto;
}

.dropzone .dz-preview .dz-error-message {
  pointer-events: none;
  z-index: 1000;
  position: absolute;
  display: block;
  display: none;
  opacity: 0;
  -webkit-transition: opacity 0.3s ease;
  -moz-transition: opacity 0.3s ease;
  -ms-transition: opacity 0.3s ease;
  -o-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  border-radius: 8px;
  font-size: 13px;
  top: 130px;
  left: -10px;
  width: 140px;
  background: #be2626;
  background: linear-gradient(to bottom, #be2626, #a92222);
  padding: 0.5em 1.2em;
  color: white;
}

.dropzone .dz-preview .dz-error-message:after {
  content: "";
  position: absolute;
  top: -6px;
  left: 64px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #be2626;
}

.vue-dropzone {
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color 0.2s linear;
}

.vue-dropzone:hover {
  background-color: #f6f6f6;
}

.vue-dropzone i {
  color: #ccc;
}

.vue-dropzone .dz-preview .dz-image {
  border-radius: 0;
  width: 100%;
  height: 100%;
}

.vue-dropzone .dz-preview .dz-image img:not([src]) {
  width: 200px;
  height: 200px;
}

.vue-dropzone .dz-preview .dz-image:hover img {
  transform: none;
  -webkit-filter: none;
}

.vue-dropzone .dz-preview .dz-details {
  bottom: 0;
  top: 0;
  color: white;
  background-color: rgba(33, 150, 243, 0.8);
  transition: opacity 0.2s linear;
  text-align: left;
}

.vue-dropzone .dz-preview .dz-details .dz-filename {
  overflow: hidden;
}

.vue-dropzone .dz-preview .dz-details .dz-filename span,
.vue-dropzone .dz-preview .dz-details .dz-size span {
  background-color: transparent;
}

.vue-dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
  border: none;
}

.vue-dropzone .dz-preview .dz-details .dz-filename:hover span {
  background-color: transparent;
  border: none;
}

.vue-dropzone .dz-preview .dz-progress .dz-upload {
  background: #cccccc;
}

.vue-dropzone .dz-preview .dz-remove {
  position: absolute;
  z-index: 30;
  color: white;
  margin-left: 15px;
  padding: 10px;
  top: inherit;
  bottom: 15px;
  border: 2px white solid;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 1.1px;
  opacity: 0;
}

.vue-dropzone .dz-preview:hover .dz-remove {
  opacity: 1;
}

.vue-dropzone .dz-preview .dz-success-mark,
.vue-dropzone .dz-preview .dz-error-mark {
  margin-left: auto;
  margin-top: auto;
  width: 100%;
  top: 35%;
  left: 0;
}

.vue-dropzone .dz-preview .dz-success-mark svg,
.vue-dropzone .dz-preview .dz-error-mark svg {
  margin-left: auto;
  margin-right: auto;
}

.vue-dropzone .dz-preview .dz-error-message {
  top: calc(15%);
  margin-left: auto;
  margin-right: auto;
  left: 0;
  width: 100%;
}

.vue-dropzone .dz-preview .dz-error-message:after {
  bottom: -6px;
  top: initial;
  border-top: 6px solid #a92222;
  border-bottom: none;
}

.group {
  position: relative;
}

input {
  font-size: 17px;

  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}

input:focus {
  outline: none;
}

/* LABEL ======================================= */
label {
  color: #999;
  font-size: 17px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  top: 10px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
input:focus ~ label,
input:valid ~ label {
  top: -20px;
  font-size: 14px;
  color: #0000ff;
}

/* BOTTOM BARS ================================= */
.bar {
  position: relative;
  display: block;
  width: 100%;
}

.bar:before,
.bar:after {
  content: "";
  height: 1px;
  width: 0;
  bottom: 1px;
  position: absolute;
  background: #0000ff;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.bar:before {
  left: 50%;
}

.bar:after {
  right: 50%;
}

/* active state */
input:focus ~ .bar:before,
input:focus ~ .bar:after {
  width: 50%;
}

/* HIGHLIGHTER ================================== */
.highlight {
  position: absolute;
  height: 60%;
  width: 100px;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

/* active state */
input:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from {
    background: #0000ff;
  }

  to {
    width: 0;
    background: transparent;
  }
}

@-moz-keyframes inputHighlighter {
  from {
    background: #0000ff;
  }

  to {
    width: 0;
    background: transparent;
  }
}

@keyframes inputHighlighter {
  from {
    background: #0000ff;
  }

  to {
    width: 0;
    background: transparent;
  }
}

#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 300px;
}

.mx-datepicker-range {
  width: 80%;
}
.headline {
  font-size: 13px !important;
}
.mx-datepicker-popup {
  top: -250px !important;
  position: static !important;
}
.mx-datepicker {
  width: 300px !important;
}
</style>
